import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5546dff2")

_pushScopeId("data-v-5546dff2")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "scoreboxbig" }
const _hoisted_4 = { class: "score" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "fen" }, "分", -1)
const _hoisted_6 = { class: "codetxt" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "name" }, "评估结果", -1)
const _hoisted_8 = { class: "val" }
const _hoisted_9 = { class: "codetxt" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "name" }, "常见症状", -1)
const _hoisted_11 = { class: "val" }
const _hoisted_12 = { class: "codetxt" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "name" }, "好发疾病", -1)
const _hoisted_14 = { class: "val" }
const _hoisted_15 = { class: "codetxt" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "name" }, "调理建议", -1)
const _hoisted_17 = { class: "val" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScoreNum = _resolveComponent("ScoreNum")

  return (_ctx.data && _ctx.data.detailInfo)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.detailInfo, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "card version7",
            key: item.detailName
          }, [
            _createVNode("div", _hoisted_2, _toDisplayString(item.detailName), 1),
            _withDirectives(_createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_ScoreNum, {
                  score: parseInt(item.score),
                  addZero: true
                }, null, 8, ["score"])
              ]),
              _hoisted_5
            ], 512), [
              [_vShow, item.score]
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("span", _hoisted_8, _toDisplayString(item.evaluationResult), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("span", _hoisted_11, _toDisplayString(item.symptom || '无'), 1)
            ]),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("span", _hoisted_14, _toDisplayString(item.warning || '无'), 1)
            ]),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("span", _hoisted_17, _toDisplayString(item.suggestion || '无'), 1)
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
})